import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
import { SubrentalOutputPrintModel } from 'src/app/models/print/subrental/subrental-output-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { SubrentalOutputTableModel } from 'src/app/models/tables/subrental/subrental-output-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubrentalOutputService {

  constructor(private _httpClient: HttpClient) { }
  createSubrentalOutput(subrentalOutputContract: InventoryOutputModel): Observable<InventoryOutputModel> {
    return this._httpClient.post<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.CreateSubrentalOutput}`,
      subrentalOutputContract);
  }

  deleteSubrentalOutput(subrentalOutputId: number): Observable<InventoryOutputModel> {
    return this._httpClient.delete<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.DeleteSubrentalOutput}/${subrentalOutputId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllSubrentalOutputTypeForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetAllSubretnalOutputTypeForSelect}`);
  }

  getAllTransporterForSelect(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetAllTransporterForSelect}/${branchId}`);
  }

  getAllVehicleForSelect(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetAllVehicleForSelect}/${branchId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetColumnsForGeneralConsultation}`);
  }

  getDevolutionForSubrentalOutput(devolutionId: number): Observable<InventoryOutputModel> {
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetDevolutionForSubrentalOutput}/${devolutionId}`);
  }

  getEmptySubrentalOutputPrint(): Observable<SubrentalOutputPrintModel> {
    return this._httpClient.get<SubrentalOutputPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetEmptySubrentalOutputPrint}`);
  }

  getFirstSubrentalOutputByKeysAsync(branchId: number, inventoryOutputTypeId: number): Observable<InventoryOutputModel> {
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('inventoryOutputTypeId', inventoryOutputTypeId);
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetFirstSubrentalOutputByKeys}`,
      { params: params });
  }

  getLastSubrentalOutputByCompanyAsync(itemFilters: Array<ItemFilterModel>): Observable<InventoryOutputModel> {
    return this._httpClient.post<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetLastSubrentalOutputByCompanyId}`,
      itemFilters);
  }

  getLastSubrentalOutputByKeysAsync(branchId: number, inventoryOutputTypeId: number): Observable<InventoryOutputModel> {
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('inventoryOutputTypeId', inventoryOutputTypeId);
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetLastSubrentalOutputByKeys}`,
      { params: params });
  }

  getNextSubrentalOutputByKeysAsync(branchId: number, inventoryOutputTypeId: number, consecutive: number | null): Observable<InventoryOutputModel> {
    let params = new HttpParams()
      .set('branchId', branchId)
      .set('inventoryOutputTypeId', inventoryOutputTypeId);
    if (consecutive !== null)
      params = params.set('consecutive', consecutive);
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetNextSubrentalOutputByKeys}`,
      { params: params });
  }

  getPreviusSubrentalOutputByKeysAsync(branchId: number, inventoryOutputTypeId: number, consecutive: number | null): Observable<InventoryOutputModel> {
    let params = new HttpParams()
      .set('branchId', branchId)
      .set('inventoryOutputTypeId', inventoryOutputTypeId);
    if (consecutive !== null)
      params = params.set('consecutive', consecutive);
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetPreviusSubrentalOutputByKeys}`,
      { params: params });
  }

  getSubrentalOutputById(subrentalOutputId: number): Observable<InventoryOutputModel> {
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetSubrentalOutputById}/${subrentalOutputId}`);
  }

  getSubrentalOutputByKeysAsync(branchId: number, inventoryOutputTypeId: number, consecutive: number): Observable<InventoryOutputModel> {
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('inventoryOutputTypeId', inventoryOutputTypeId)
      .set('consecutive', consecutive);
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetSubrentalOutputByKeys}`,
      { params: params });
  }

  getSubrentalOutputByKeysByPrint(branchId: number, consecutive: number, subrentalOutputId: number): Observable<SubrentalOutputPrintModel> {
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('consecutive', consecutive)
      .set('subrentalOutputId', subrentalOutputId);
    return this._httpClient.get<SubrentalOutputPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetSubrentalOutputPrintByKeys}`,
      { params: params });
  }

  getSubrentalOutputByKeysForFormats(itemFilters: Array<ItemFilterModel>): Observable<InventoryOutputModel> {
    return this._httpClient.post<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetSubrentalOutputByKeysForFormats}`,
      itemFilters);
  }

  getSubrentalOutputsForGeneralConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<SubrentalOutputTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<SubrentalOutputTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.GetSubrentalOutputsForGeneralConsultation}`,
      filters, { params: params }
    );
  }

  setSubrentalOutputState(subrentalOutputId: number): Observable<InventoryOutputModel> {
    return this._httpClient.put<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.SetSubrentalOutputState}/${subrentalOutputId}`,
      null);
  }

  updateSubrentalOutput(subrentalOutputContract: InventoryOutputModel): Observable<InventoryOutputModel> {
    return this._httpClient.put<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutput.UpdateSubrentalOutput}`,
      subrentalOutputContract);
  }

}
